import { http, HttpResponse } from 'msw';

const handlers = [
  http.get(
    '/api/cluster-autoscaler/v1beta/organizations/:organizationId/hibernation-schedules',
    () => {
      return HttpResponse.json({ items: [] });
    }
  ),
];

export default handlers;
